<div class="uber-wrap" [ngClass]="{ 'in-dashboard': page == 'my-account' }">
  <div class="text-center space-between">
    <div class="space-between logo-wrap w-100">
      <img
        src="assets/images/Uber-Driver-App-logo.png"
        alt="uber logo"
        class="logo-img"
        />
      <button type="button" mat-icon-button mat-dialog-close aria-label="Dismiss and close">
        <mat-icon>repeat</mat-icon>
      </button>
      <span class="pink-cont">
        <img
          src="assets/images/circle-octo-logo.svg"
          alt="octopus logo"
          class="logo-img octo-img"
          />
      </span>
    </div>
    @if (isReauthChecking) {
      <div class="loading-spinner-container">
        <mat-spinner diameter="17"></mat-spinner>
        <span>Loading...</span>
      </div>
    } @else {
    <h1 class="step-heading w-100">{{ needsUberReauth ? 'Relink Your Uber Account' : 'Link Your Uber Account' }}</h1>
    @if (needsUberReauth) {
      <p class="w-100 mb-0">{{ uberReauthMessage }}</p>
    }
    <div class="w-100">
        <p>
          You will be sharing your name, phone number, email address,
          profile picture, preferred language, vehicle(s) make/model/year
          and activation status (active, onboarding, etc.) with Octopus.
        </p>
        <p>
          Octopus will use this information to connect your Uber account
          to the Octopus tablet and display the Uber Journey TV experience
          to your Uber riders, in accordance with
          <a
            id="uber-privacynotice-link"
            href="https://www.uber.com/legal/en/document/?name=privacy-notice&country=united-states&lang=en"
            target="_blank"
            >Uber's Privacy Notice</a
            >.
          </p>
        @if (
          !needsUberReauth &&
          (userSummary?.uber_connect?.status?.toUpperCase() ===
          'CONNECTED' ||
          (userSummary?.journey_tv?.matched_identifier?.length > 0 &&
          userSummary?.journey_tv?.matched_identifier !== null))
          ) {
          <div
            class="uber-connect-container"
            >
            <div class="connect-button">
              <img
                src="assets/images/Uber-Driver-App-logo.png"
                alt="Uber Logo"
                />
              <span>Your Uber Account is linked successfully.</span>
            </div>
          </div>
        }
        @if (isGuardLoading) {
            <div class="loading-spinner-container">
              <mat-spinner diameter="17"></mat-spinner>
              <span>Loading...</span>
            </div>
        }

        @if (!isGuardLoading) {
          @if (isNotUberConnected && !needsUberReauth) {
            <button
              class="btn"
              id="uber-link-button"
              (click)="linkAccount()"
              >
              Link Account
            </button>
          }
          @if (!needsUberReauth && !userSummary?.isReferredByUberPartner) {
            <button
              (click)="gotoCurrentPage()"
              id="uber-skiplink-button"
              class="w-100 link-btn"
              [ngClass]="{ 'dashboard-btn': page == 'my-account' }"
              >
              Connect Later
            </button>
          }
          @if (needsUberReauth) {
            <button
              class="btn"
              id="uber-relink-button"
              (click)="linkAccount()"
              >
              Relink Account
            </button>
          }
        }
      </div>
    }
    </div>
  </div>
